<template src="./templates/support-review.html" />

<script type="text/ecmascript-6">
import FouGrid from 'src/components/layout/fou-grid/'
import FouGroup from 'src/components/layout/fou-group/'
import FouContainer from 'src/components/tools/fou-container/'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import Preview from 'src/pages/submissions/components/preview/'
import ReviewStatusIcons from 'src/pages/submissions/components/review-status-icons/'
import Misc from 'src/utils/helper/misc'
import Validator from 'src/pages/submissions/components/validator/'
import SubmissionLoading from 'src/pages/submissions/components/loading/'
import { SubmissionObject } from 'src/pages/submissions/script/common.data'
import MessageHistory from 'src/pages/submissions/components/message-history/'
import {
  mapActions,
  mapGetters
} from 'vuex'
import YupValidationMethods from 'src/pages/submissions/script/yup.validation.methods'
import FouModal from 'src/components/overlay/fou-modal/'
import Content from 'src/assets/i18n/en.json'
import get from 'lodash/get'
import TextEditor from 'components/form/text-editor/index.vue'

export default {
  name: 'SubmissionsSupportReview',

  components: {
    ...FouGrid,
    FouGroup,
    FouContainer,
    Preview,
    FouModal,
    SubmissionLoading,
    ReviewStatusIcons,
    Validator,
    MessageHistory,
    TextEditor
  },

  data() {
    return {
      ...SubmissionObject,
      status: null,
      description: '',
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      userId: null,
      validationWarnings: false,
      messageSectionVisible: false,
      expandButtonText: get(Content, 'pages.submissions.review.message_history_btn.more'),
      stepsHasErrors: false,
      defaultErrorLabel: '',
      styleUrlErrors: [],
      errorsLogged: [],
      disableRetest: false,
      modalOptions: {
        cols: '',
        content: []
      }
    }
  },
  computed: {
    ...SubmissionComputed,
    ...mapGetters('foundrySupport', {
      supportUsers: ['list']
    }),
    releaseDate() {
      return this.submission?.userMetaData?.releaseInfo?.releaseDate
        ? this.formatDate(this.submission.userMetaData.releaseInfo.releaseDate, this.$i18n.locale, ' ll')
        : this.$t('pages.submissions.review.approve.release_asap')
    },
    disableSubmitButton: {
      get() {
        return (this.status === 'in_review')
      }
    },
    showRetestButton() {
      return this.$store.getters['binaries/list'].some((item) => item.validationResult.progress.complete === false)
    }
  },

  created() {
    this.resetSubmissionObjectBuilds()
    this.resetSubmissionFormat()
    this.addReadyState()
    this.init()
  },
  beforeUnmount() {
    this.$store
      .dispatch('submissions/reset').then(() => {
        this.$store.commit('binaries/clear')
        this.$store.commit('designers/clear')
        this.$store.commit('graphics/clear')
        this.$store.commit('tags/clear')
      })
  },
  methods: {
    ...Misc,
    ...SubmissionMethods,
    ...YupValidationMethods,
    ...mapActions('foundrySupport', ['getSupportUsers']),
    ...mapActions('overlay', ['hide', 'show']),
    navigateToEdit() {
      this.$router.push({
        name: 'submissions_support_edit',
        params: {
          id: this.submission.id,
          stepsHasErrorsUrl: this.stepsHasErrors
        }
      })
    },
    navigateToDashboard() {
      this.$router.push({
        name: 'home'
      })
    },
    submitReview() {
      this.setDefaultUser()
      this.submission.description = this.description || ''
      this.submission.status = this.status
      this.$store.dispatch('submissions/update', this.submission)
    },
    checkValidation() {
      this.validationWarnings = ['WARN', 'ERROR'].indexOf(this.submission.validationResult.errorLevel) >= 0 ||
        this.$store.getters['binaries/list'].some(b => ['WARN', 'ERROR'].indexOf(b.validationResult.errorLevel) >= 0)
    },
    init() {
      return new Promise(resolve => {
        YupValidationMethods.runAllValidations(this)
        this
          .startSubmission()
          .then(() => {
            const load = [
              this.$store.dispatch('binaries/getAll', {
                submissionId: this.submission.id
              }),
              this.$store.dispatch('graphics/getAll', {
                submissionId: this.submission.id
              }),
              this.getSupportUsers(),
              this.updateSubmissionSteps(),
              this.getFoundryForSubmission()
            ]
            Promise
              .all(load)
              .then(() => {
                this.checkValidation()
                this.ready.state = 'set'
                this.status = this.submission.status
              })
              .then(resolve)
              .catch(resolve)
          })
      })
    },
    toggleStatus(status) {
      return new Promise(resolve => {
        if (status === 'approved') {
          this
            .setValidationSchema(this)
            .validate({ ...this.submission }, { abortEarly: false })
            .catch(err => {
              this.errorsLogged = [...err.errors, ...this.errorsLogged]
              if (this.errorsLogged.length > 0) {
                this.stepsHasErrors = true
                this.status = 'in_review'
              } else {
                this.stepsHasErrors = false
                this.status = 'approved'
              }
              resolve()
            })
        } else {
          this.stepsHasErrors = false
          this.status = status
        }
      })
    },
    validateErrorLevel(binaryList, submission) {
      const validationData = [...binaryList, submission]
      const errorsLevel = validationData.filter((val) => val.validationResult.errorLevel === 'ERROR')
      return errorsLevel.length > 0
    },
    disableRetestButton() {
      this.disableRetest = true
    },
    retestValidation() {
      return new Promise(resolve => {
        this.disableRetestButton()
        this.$store.dispatch('submissions/triggerBinaryValidation', {
          submissionId: this.submission.id
        }).then((response) => {
          if (response?.success === true) {
            const root = document.getElementById('app');
            root.style.overflow = 'hidden';
            const modalDiv = document.getElementById('retest-modal')
            modalDiv.style.display = 'block'
            resolve()
          }
        })
      })
    },
    closeRetestModal(){
      const root = document.getElementById('app');
      root.style.overflow = 'auto';
      const modalDiv = document.getElementById('retest-modal');
      modalDiv.style.display = 'none';
    }
  }
}
</script>

<style src="./stylesheets/index.scss" lang="scss" module></style>
